import { useEffect, useState } from 'react'
import { guideVideo, guideSlugOf, GUIDE_LINK_LABEL } from '../lib/pageHelp'

// "▶ Watch the 1-min guide": the guide video plays INSIDE the app, in a window (heycaptain.io/media/guides/<slug>.mp4, else the
// clip media/clips/clip-<slug>.mp4 - src/lib/pageHelp.js guideVideo). A video that is not there says so, with the guide page link.
export function GuidePlayer({ slug, title, onClose }) {
  const g = guideVideo(slug)
  const [i, setI] = useState(0)
  useEffect(() => {
    const k = e => { if (e.key === 'Escape') onClose() }
    window.addEventListener('keydown', k)
    return () => window.removeEventListener('keydown', k)
  }, [onClose])
  if (!g) return null
  const src = g.sources[i]
  return (
    <div role="dialog" aria-modal="true" aria-label={title || 'Guide video'} onClick={e => { if (e.target === e.currentTarget) onClose() }}
      style={{ position: 'fixed', inset: 0, zIndex: 3000, background: 'rgba(4,10,20,.82)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 16 }}>
      <div style={{ width: 'min(900px, 100%)', background: 'var(--card, #11161e)', border: '1px solid var(--border, rgba(255,255,255,.1))', borderRadius: 12, overflow: 'hidden' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '10px 14px', borderBottom: '1px solid var(--border, rgba(255,255,255,.1))' }}>
          <b style={{ fontSize: 14, color: 'var(--text)', flex: 1, minWidth: 0, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{title || 'Guide'}</b>
          <a href={g.page} target="_blank" rel="noopener noreferrer" style={{ fontSize: 12, color: 'var(--muted)' }}>Open on heycaptain.io</a>
          <button onClick={onClose} aria-label="Close" style={{ background: 'none', border: 'none', color: 'var(--muted)', fontSize: 18, cursor: 'pointer' }}>✕</button>
        </div>
        {src
          ? <video key={src.src} className="hc-guide-video" src={src.src} poster={src.poster} controls autoPlay playsInline preload="metadata"
              onError={() => setI(n => n + 1)} style={{ display: 'block', width: '100%', maxHeight: '75vh', background: '#000' }} />
          : <div style={{ padding: '40px 20px', textAlign: 'center', color: 'var(--muted)', fontSize: 13.5 }}>
              {g.notOnline ? 'This guide video is not online yet.' : 'The guide video could not be loaded.'}{' '}
              <a href={g.page} target="_blank" rel="noopener noreferrer" style={{ color: 'var(--gold2, #c9a84c)' }}>See the guides on heycaptain.io</a>
            </div>}
      </div>
    </div>
  )
}

// the link / button that opens it: page = a page key (survey_readiness) or url = a guide link from the AI (guides#<slug>)
export default function GuideButton({ page, url, label, title, style, className }) {
  const [open, setOpen] = useState(false)
  const slug = guideSlugOf(url || page), g = guideVideo(slug)
  if (!g || g.notOnline) return null   // no guide, or its video is not on heycaptain.io yet
  return (
    <>
      <button type="button" className={className || 'hc-guide-link'} onClick={() => setOpen(true)}
        style={{ background: 'none', border: 'none', padding: 0, color: 'var(--gold2, #c9a84c)', fontSize: 13, fontWeight: 600, cursor: 'pointer', textAlign: 'left', ...style }}>
        {label || GUIDE_LINK_LABEL}
      </button>
      {open && <GuidePlayer slug={slug} title={title} onClose={() => setOpen(false)} />}
    </>
  )
}
